import { AxiosError } from 'axios';

type ServerErrorBody = { message?: string | string[] };

/**
 * Pull the backend's human-readable message out of an axios error envelope
 * ({ statusCode, error, message, ... } from the global HttpExceptionFilter).
 * Returns the string (or the first entry of an array), or undefined when the
 * error carries no server message (e.g. a network failure or a non-axios error)
 * so callers can fall back to a generic message.
 */
export const getApiErrorMessage = (error: unknown): string | undefined => {
  if (!(error instanceof AxiosError)) return undefined;
  const message = (error.response?.data as ServerErrorBody | undefined)?.message;
  if (typeof message === 'string' && message.trim()) return message;
  if (Array.isArray(message) && message.length) return message[0];
  return undefined;
};
